function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["isLoading", "delay", "postDelay", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { useSpring, animated } from "@react-spring/web";
import LoadingAnimation from "../loadinganimation/LoadingAnimation";
var DEFAULT_DELAY = 1000;
var DEFAULT_POST_DELAY = 300;
var K100 = "#f7f8f9";
function alpha(color, num) {
  var value = num * 255;
  var hex = value.toString(16).padStart(2, "0");
  var newColor = color[0] === "#" ? color.substring(1, 7) : color.substring(0, 6);
  return "#".concat(newColor).concat(hex);
}
var LoadingOverlay = function LoadingOverlay(_ref) {
  var isLoading = _ref.isLoading,
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? 2000 : _ref$duration,
    _ref$isTableRowLoader = _ref.isTableRowLoader,
    isTableRowLoader = _ref$isTableRowLoader === void 0 ? false : _ref$isTableRowLoader;
  var styles = useSpring({
    background: isLoading ? alpha(K100, 0.8) : alpha(K100, 0),
    opacity: isLoading ? 1 : 0,
    config: {
      duration: duration
    }
  });
  var overlayProps = {
    style: {
      background: styles.background,
      left: isTableRowLoader ? 0 : "inherit"
    },
    className: "tui-loading-overlay ".concat(isLoading ? "is-loading" : ""),
    role: "progressbar",
    "aria-busy": isLoading
  };
  var children = /*#__PURE__*/React.createElement(animated.div, {
    style: {
      opacity: styles.opacity
    }
  }, /*#__PURE__*/React.createElement(LoadingAnimation, {
    delay: 0
  }));
  return isTableRowLoader ? /*#__PURE__*/React.createElement(animated.td, overlayProps, children) : /*#__PURE__*/React.createElement(animated.div, overlayProps, children);
};
export function useDelayedLoading(_ref2) {
  var isLoading = _ref2.isLoading,
    _ref2$delay = _ref2.delay,
    delay = _ref2$delay === void 0 ? DEFAULT_DELAY : _ref2$delay,
    _ref2$postDelay = _ref2.postDelay,
    postDelay = _ref2$postDelay === void 0 ? DEFAULT_POST_DELAY : _ref2$postDelay;
  var _useState = useState(isLoading),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var timeout = useRef();
  var loadingTimeStamp = useRef();
  useEffect(function () {
    if (timeout.current) clearTimeout(timeout.current);
    var scopeTimeout = window.setTimeout(function () {
      setLoading(isLoading);
      timeout.current = null;
      loadingTimeStamp.current = Date.now();
    }, isLoading ? delay : postDelay);
    timeout.current = scopeTimeout;
    return function () {
      return void clearTimeout(scopeTimeout);
    };
  }, [isLoading, delay, postDelay]);
  return loading;
}
var Loader = function Loader(_ref3) {
  var isLoading = _ref3.isLoading,
    _ref3$delay = _ref3.delay,
    delay = _ref3$delay === void 0 ? DEFAULT_DELAY : _ref3$delay,
    _ref3$postDelay = _ref3.postDelay,
    postDelay = _ref3$postDelay === void 0 ? DEFAULT_POST_DELAY : _ref3$postDelay,
    children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded);
  var loading = useDelayedLoading({
    isLoading: isLoading,
    delay: delay,
    postDelay: postDelay
  });
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    style: _objectSpread({
      position: "relative"
    }, props.style)
  }), children, /*#__PURE__*/React.createElement(LoadingOverlay, {
    isLoading: loading
  }));
};
export { Loader, LoadingOverlay };
//# sourceMappingURL=Loader.js.map